/* ============================================================
   ToyZone Discount Band Auto-Color (2026-10-17)
   Reads the product's main image, extracts its dominant vibrant
   color (ignoring white backgrounds), and tints the discount
   ticket band to match. Falls back to the theme's green.
   Enabled via Theme Settings toggle (window.tzDiscountAutocolor).
   ============================================================ */
(function () {
  'use strict';
  if (!window.tzDiscountAutocolor) return;

  function findBand() {
    var els = document.querySelectorAll('[class*="tz-db-middle-band-"]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].className.indexOf('tz-db-middle-band-') !== -1) return els[i];
    }
    return null;
  }

  function darken(r, g, b, f) {
    return 'rgb(' + Math.round(r * f) + ',' + Math.round(g * f) + ',' + Math.round(b * f) + ')';
  }

  function applyColor(r, g, b) {
    var band = findBand();
    if (!band) return;
    var light = 'rgb(' + r + ',' + g + ',' + b + ')';
    band.style.background = 'linear-gradient(135deg,' + light + ',' + darken(r, g, b, 0.62) + ')';
  }

  function extract(imgUrl) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var s = 48, c = document.createElement('canvas');
        c.width = s; c.height = s;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, s, s);
        var d = ctx.getImageData(0, 0, s, s).data;
        var buckets = {};
        for (var i = 0; i < d.length; i += 16) {
          var r = d[i], g = d[i + 1], b = d[i + 2];
          var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
          if (mx > 235 && mn > 210) continue;   /* white background */
          if (mx < 20) continue;                  /* near black */
          if (mx - mn < 35) continue;             /* grays */
          var k = (r >> 5) + ',' + (g >> 5) + ',' + (b >> 5);
          buckets[k] = (buckets[k] || 0) + 1;
        }
        var best = null, bc = 0;
        for (var k in buckets) { if (buckets[k] > bc) { bc = buckets[k]; best = k; } }
        if (!best) return;
        var p = best.split(',');
        applyColor(
          Math.min(255, (+p[0] * 32) + 16),
          Math.min(255, (+p[1] * 32) + 16),
          Math.min(255, (+p[2] * 32) + 16)
        );
      } catch (e) { /* keep default green */ }
    };
    img.onerror = function () { /* keep default green */ };
    img.src = imgUrl;
  }

  function init() {
    if (!findBand()) return;
    var og = document.querySelector('meta[property="og:image"]');
    if (og && og.getAttribute('content')) extract(og.getAttribute('content'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
